// Abrir o monitor Live de uma rota numa janela própria — permite ao
// operador acompanhar várias rotas em simultâneo, cada uma na sua janela.
//
// Como funciona:
//   • A janela carrega o entry-point por hash `#/live/<routeId>` (ver
//     App.js → LiveWindow.js), que monta apenas o LiveRouteMonitor.
//   • O JWT é passado via localStorage (mesma origem, partilhado entre
//     janelas) — nunca vai no URL. A janela copia-o para o seu próprio
//     sessionStorage e apaga a chave, por isso sobrevive a um refresh.
//   • O nome de janela `ecoLive_<routeId>` é estável: reabrir a mesma
//     rota foca a janela existente em vez de duplicar (poupa recursos).

const LIVE_TOKEN_KEY = 'planner_live_token';

/**
 * @param {number|string} routeId
 * @param {string} token JWT do operador
 * @returns {Window|null} a janela aberta, ou null se o browser bloqueou o popup
 */
export function openLiveWindow(routeId, token) {
  if (!routeId) return null;
  try {
    if (token) localStorage.setItem(LIVE_TOKEN_KEY, token);
  } catch { /* localStorage indisponível — a janela mostrará "sessão expirada" */ }

  const url = `${window.location.origin}${window.location.pathname}#/live/${routeId}`;
  const w = window.open(
    url,
    `ecoLive_${routeId}`,
    'width=1320,height=880,menubar=no,toolbar=no,location=no,status=no',
  );
  if (w) { try { w.focus(); } catch { /* ignore */ } }
  return w;
}

export { LIVE_TOKEN_KEY };
